const MMKManager = [
  {
    title: 'Dashboard',
    is_heading: false,
    is_active: false,
    link: {
      name: 'mkm.dashboard'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-objects-column',
    active_icon: 'fad fa-objects-column'
  },
  {
    title: 'Memos',
    is_heading: false,
    is_active: false,
    link: {
      name: 'mkm.memos'
    },
    class_name: '',
    collapsable: false,
    is_icon_class: true,
    icon: 'fat fa-file-pdf',
    active_icon: 'fad fa-file-pdf',
    children: [
      {
        link: {
          name: 'mkm.memos.signed-memos'
        }
      }
    ]
  }
]

export default MMKManager
